import { Injectable } from '@angular/core';
import {HttpClient,  HttpHeaders, HttpResponse}from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';
import{Da9000Class}from '../../Class/da9000/da9000-class';
import * as XLSX from 'xlsx-js-style';

// Declare the XLSX object from the CDN

@Injectable({
  providedIn: 'root',
})

export class CommonService {

  baseUrl: string=environment.baseUrl + 'Common/';

  constructor(private http:HttpClient) { }

  ReadLoginuserName():Observable<any>
  {
    rtn: String;
    return this.http.get<any>(this.baseUrl+'ReadLoginuserName');
  }
  
  TempFileCreate(file: any): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<any>(this.baseUrl + 'Upload', file,{reportProgress: true, observe: 'events'});
  }

  //Save file
  Save(subdesignation_class:Da9000Class): Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'Save',subdesignation_class);
  }
  
  //Select file
  SelectAttachments(subdesignation_class:Da9000Class): Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'SelectAttachments',subdesignation_class);
  }

  DownloadTemplate(TableName: any, FileName : any) : string 
  {
    var csv = [];
    var oTable =(<HTMLFormElement>document.getElementById(TableName)) ;
    var rowLength = oTable.rows.length;
    for (var i = 0; i < rowLength; i++) {
        var row = [];
        var oCells = oTable.rows.item(i).cells;
        var cellLength = oCells.length;
        for (var j = 0; j < cellLength; j++) {
            row.push(oCells.item(j).innerText);
        }
        csv.push(row.join(","));
    }
    this.downloadCSV(csv.join("\n"), FileName + ".csv");
    return "";
  }

DownloadExcelTemplateXlsxVISA(TableName: string, FileName: string,CompName:string): void {
const oTable = document.getElementById(TableName) as HTMLTableElement;

// Step 1: Convert table to sheet
let worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(oTable, { raw: true });

// Step 2: Fix number conversion
const range = XLSX.utils.decode_range(worksheet['!ref']!);
for (let R = range.s.r; R <= range.e.r; ++R) {
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
    const cell = worksheet[cellRef];
    if (
      cell &&
      typeof cell.v === 'string' &&
      cell.v.trim() !== '' &&
      !isNaN(Number(cell.v)) &&
      !/^0\d+/.test(cell.v.trim())
    ) {
      cell.v = Number(cell.v);
      cell.t = 'n';
    }
  }
}

// Step 3: Get data, add heading rows
const originalData: (string | number | null)[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

const newData: (string | number | null)[][] = [
  [null, null, null, CompName],                // C1
  [null, null, null, 'WORK VISA DETAILS'],     // C2
  ...originalData                        // from row 3 onwards
];

worksheet = XLSX.utils.aoa_to_sheet(newData);
const maxColumns1 = Math.max(...newData.map(row => row.length));

// Function to apply bold style to a row
function makeRowBold(rowIndex: number) {
  for (let c = 0; c < maxColumns1; c++) {
    const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c });
    const cell = worksheet[cellRef];
    if (cell) {
      // Initialize style if not present
      cell.s = cell.s || {};
      cell.s.font = { ...cell.s.font, bold: true };
    }
  }
}

// Apply bold to first two rows
makeRowBold(0); // first row (CompName)
makeRowBold(1); // second row (WORK VISA DETAILS)


// Step 5: Auto column widths
    const colWidths = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxWidth = 10;
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        if (cell && cell.v != null) {
          const cellValue = cell.v.toString();
          maxWidth = Math.max(maxWidth, cellValue.length);
        }
      }
      colWidths.push({ wch: maxWidth + 2 });
    }
worksheet['!cols'] = colWidths;
// Assign column widths to worksheet
worksheet['!cols'] = colWidths;

const headerRowIndex =3;
const maxColumns = Math.max(...newData.map(row => row.length));
for (let c = 0; c < maxColumns; c++) {
  const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c });
  const cell = worksheet[cellRef];
  if (cell) {
    cell.s = {
      fill: {
        fgColor: { rgb: '5E8BC2' }, // Blue
      },
      font: {
        bold: true,
        color: { rgb: 'FFFFFF' },
      },
      alignment: {
        horizontal: 'center',
      },
    };
  }
}

//Second Table
let headerRowIndex1 = -1;


for (let i = 0; i < newData.length; i++) {
  const row = newData[i];
  if (
     row[0] != null &&
    row[1] != null &&
    row[0].toString().trim() === 'Country' &&
    row[1].toString().trim() === 'Count'
  ) {
    headerRowIndex1 = i;
    break;
  }
}
const secondHeaderRowIndex =headerRowIndex1;

for (let c = 0; c < maxColumns; c++) {
  const cellRef = XLSX.utils.encode_cell({ r: secondHeaderRowIndex, c });
  const cell = worksheet[cellRef];
  if (cell) {
    cell.s = {
      fill: { fgColor: { rgb: '5E8BC2' } },
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'center' }
    };
  }
}
//Update Total as red
const lastRowIndex = newData.length - 1;

for (let c = 0; c < maxColumns; c++) {
  const cellRef = XLSX.utils.encode_cell({ r: lastRowIndex, c });
  const cell = worksheet[cellRef];
  if (cell) {
    cell.s = {
      fill: {
        fgColor: { rgb: 'BFBFBF' }, // Red background
      },
      font: {
        bold: true,
        color: { rgb: '000000' },   // black text
      },
      alignment: {
        horizontal: 'right',
      },
    };
  }
}
// Step 7: Export the workbook
const workbook: XLSX.WorkBook = {
  Sheets: { Sheet1: worksheet },
  SheetNames: ['Sheet1'],
};

XLSX.writeFile(workbook, FileName + '.xlsx');

  }

  DownloadExcelTemplateXlsx(TableName: string, FileName: string): void {
    const oTable = document.getElementById(TableName) as HTMLTableElement;
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(oTable, { raw: true });
    // Fix number conversion: Convert numeric strings to numbers
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        
         if (cell && typeof cell.v === 'string' && cell.v.trim() !== '' && !isNaN(Number(cell.v)) &&!/^0\d+/.test(cell.v.trim())) {
              cell.v = Number(cell.v);
              cell.t = 'n'; // Set the cell type to number
          }

      }
    }

    // Auto width for each column
    const colWidths = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxWidth = 10;
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        if (cell && cell.v != null) {
          const cellValue = cell.v.toString();
          maxWidth = Math.max(maxWidth, cellValue.length);
        }
      }
      colWidths.push({ wch: maxWidth + 2 });
    }
    worksheet['!cols'] = colWidths;

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Sheet1': worksheet },
      SheetNames: ['Sheet1'],
    };

    XLSX.writeFile(workbook, FileName + '.xlsx');
  }


  DownloadExcelTemplate(TableName: any, FileName : any) : string 
  {
    const oTable = document.getElementById(TableName) as HTMLTableElement;
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(oTable, { raw: true });
    
    // Auto width for each column
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    const colWidths = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxWidth = 10;
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        if (cell && cell.v != null) {
          const cellValue = cell.v.toString();
          maxWidth = Math.max(maxWidth, cellValue.length);
        }
      }
      colWidths.push({ wch: maxWidth + 2 });
    }
    worksheet['!cols'] = colWidths;

    // Add gray background color to header row (first row)
    const headerRowIndex = 0;
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: C });
      const cell = worksheet[cellRef];
      if (cell) {
        cell.s = {
          fill: {
            fgColor: { rgb: 'D3D3D3' } // Light gray
          },
          font: {
            bold: true,
            color: { rgb: '000000' }
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        };
      }
    }

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Sheet1': worksheet },
      SheetNames: ['Sheet1'],
    };

    XLSX.writeFile(workbook, FileName + '.xlsx');
    return "";
  }

  downloadExcel(csv, filename) {
    var csvFile;
    var downloadLink;
    
    csvFile = new Blob([csv], { type: "application/vnd.ms-excel" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  downloadCSV(csv, filename) {
    var csvFile;
    var downloadLink;
    
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  // ReadExcelFile(ParamFile: any, TableDiv: any) : string 
  // {
  //   var TblHtml = "<div style=\"overflow-x:auto;overflow-y:auto; height:500px;\">";
  //   TblHtml = TblHtml + "<table class=\"table table-bordered table-striped table-condensed flip-content border-bottom-white\" id=\"fileUploadTbl\" name=\"fileUploadTbl\">";
  //   var inputFile = (document.getElementById(ParamFile)) as HTMLInputElement;

  //   var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv|.txt|.xls)$/;
  //   if (regex.test(inputFile.value.toLowerCase())) 
  //   {
  //       if (typeof (FileReader) != "undefined") 
  //       {
  //           var reader = new FileReader();
  //           reader.onload = function (e) 
  //           {
  //               var rows = (reader.result).toString().split("\n");
  //               for (var i = 0; i < rows.length - 1; i++) 
  //               {
  //                   var cells = rows[i].split("\t");
  //                   //thead tbody
  //                   if(i == 0){
  //                     TblHtml = TblHtml + "<thead>";
  //                   }
  //                   else if(i == 1){
  //                     TblHtml = TblHtml + "<tbody>";
  //                   }

  //                   //tr
  //                   TblHtml = TblHtml + "<tr>";
  //                   for(var j = 0; j < cells.length; j++)
  //                   {
  //                     if(i == 0){
  //                       TblHtml = TblHtml + "<th style=\"white-space:nowrap; position:sticky;\">";
  //                       TblHtml = TblHtml + cells[j].toString();
  //                       TblHtml = TblHtml + "</th>";
  //                     }
  //                     else{
  //                       TblHtml = TblHtml + "<td style=\"white-space:nowrap;\">";
  //                       TblHtml = TblHtml + cells[j].toString();
  //                       TblHtml = TblHtml + "</td>";
  //                     }
  //                   }
  //                   TblHtml = TblHtml + "</tr>";

  //                   //thead tbody
  //                   if(i == 0){
  //                     TblHtml = TblHtml + "</thead>";
  //                   }
  //                   // else if(i == 1){
  //                   //   TblHtml = TblHtml + "</tbody>";
  //                   // }
  //               }
  //               TblHtml = TblHtml + "</tbody>";
  //               TblHtml = TblHtml + "</table>";
  //               TblHtml = TblHtml + "</div>";
  //               document.getElementById(TableDiv).innerHTML = TblHtml;
  //           }
  //           reader.readAsText(inputFile.files[0]);
  //       } 
  //       else 
  //       {
  //           alert("This browser does not support HTML5.");
  //       }
  //   }
  //   else 
  //   {
  //       alert("Please upload a valid Excel file.");
  //   }
  //   return TblHtml;
  // }


  ReadExcelFile(ParamFile: any, TableDiv: any): string
{
  const inputFile = document.getElementById(ParamFile) as HTMLInputElement;
  const file = inputFile && inputFile.files && inputFile.files[0];

  if (!file || !/\.(csv|txt|xls|xlsx)$/i.test(file.name)) {
    alert("Please upload a valid Excel file.");
    return "";
  }
  if (typeof FileReader === "undefined") {
    alert("This browser does not support HTML5.");
    return "";
  }

  const reader = new FileReader();
  reader.onload = () => {
    const buf = reader.result as ArrayBuffer;
    const bytes = new Uint8Array(buf);
    const isXlsx = bytes[0] === 0x50 && bytes[1] === 0x4B;   // "PK" zip => .xlsx
    const isXls  = bytes[0] === 0xD0 && bytes[1] === 0xCF;   // OLE => real .xls
    let rows: string[][] = [];

    try {
      if (isXlsx || isXls) {
        const wb = XLSX.read(buf, { type: 'array', cellDates: true });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: '', blankrows: false });
        rows = data.map(r => r.map(v => this.excelCellToText(v)));
      } else {
        // legacy tab-delimited text saved as .xls / .txt / .csv
        const text = new TextDecoder('utf-8').decode(buf);
        rows = text.split(/\r?\n/).filter(l => l.trim() !== '').map(l => l.split('\t'));
      }
    } catch (err) {
      alert("Please upload a valid Excel file.");
      return;
    }

    if (rows.length === 0) {
      alert("The selected file is empty.");
      return;
    }

    const colCount = rows[0].length;
    const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    let html = "<div style=\"overflow-x:auto;overflow-y:auto; height:500px;\">";
    html += "<table class=\"table table-bordered table-striped table-condensed flip-content border-bottom-white\" id=\"fileUploadTbl\" name=\"fileUploadTbl\">";

    rows.forEach((row, i) => {
      if (i === 0) html += "<thead>";
      else if (i === 1) html += "<tbody>";
      html += "<tr>";
      for (let j = 0; j < colCount; j++) {
        const val = esc(row[j] !== undefined ? row[j] : '');
        html += i === 0
          ? `<th style="white-space:nowrap; position:sticky;">${val}</th>`
          : `<td style="white-space:nowrap;">${val}</td>`;
      }
      html += "</tr>";
      if (i === 0) html += "</thead>";
    });

    html += "</tbody></table></div>";
    document.getElementById(TableDiv).innerHTML = html;
  };
  reader.readAsArrayBuffer(file);
  return "";
}

private excelCellToText(v: any): string
{
  if (v === null || v === undefined) return '';
  if (v instanceof Date) {
    // +12h avoids off-by-one-day issues from timezone rounding
    const d = new Date(v.getTime() + 12 * 3600 * 1000);
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${d.getFullYear()}-${mm}-${dd}`;      // yyyy-MM-dd, which your datePipe handles
  }
  return String(v).trim();
}

  ViewCSVFile(ParamFile: any, TableDiv: any) : string 
  {
    var TblHtml = "<div style=\"overflow-x:auto;overflow-y:auto; height:500px;\">";
    TblHtml = TblHtml + "<table class=\"table table-bordered table-striped table-condensed flip-content border-bottom-white\" id=\"fileUploadTbl\" name=\"fileUploadTbl\">";
    var inputFile = (document.getElementById(ParamFile)) as HTMLInputElement;

    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv|.txt)$/;
    if (regex.test(inputFile.value.toLowerCase())) 
    {
        if (typeof (FileReader) != "undefined") 
        {
            var reader = new FileReader();
            reader.onload = function (e) 
            {
                var rows = (reader.result).toString().split("\n");
                for (var i = 0; i < rows.length - 1; i++) 
                {
                    var cells = rows[i].split(",");
                    //thead tbody
                    if(i == 0){
                      TblHtml = TblHtml + "<thead>";
                    }
                    else if(i == 1){
                      TblHtml = TblHtml + "<tbody>";
                    }

                    //tr
                    TblHtml = TblHtml + "<tr>";
                    for(var j = 0; j < cells.length; j++)
                    {
                      if(i == 0){
                        TblHtml = TblHtml + "<th style=\"white-space:nowrap; position:sticky;\">";
                        TblHtml = TblHtml + cells[j].toString();
                        TblHtml = TblHtml + "</th>";
                      }
                      else{
                        TblHtml = TblHtml + "<td style=\"white-space:nowrap;\">";
                        TblHtml = TblHtml + cells[j].toString();
                        TblHtml = TblHtml + "</td>";
                      }
                    }
                    TblHtml = TblHtml + "</tr>";

                    //thead tbody
                    if(i == 0){
                      TblHtml = TblHtml + "</thead>";
                    }
                    // else if(i == 1){
                    //   TblHtml = TblHtml + "</tbody>";
                    // }
                }
                TblHtml = TblHtml + "</tbody>";
                TblHtml = TblHtml + "</table>";
                TblHtml = TblHtml + "</div>";
                document.getElementById(TableDiv).innerHTML = TblHtml;
            }
            reader.readAsText(inputFile.files[0]);
        } 
        else 
        {
            alert("This browser does not support HTML5.");
        }
    }
    else 
    {
        alert("Please upload a valid CSV file.");
    }
    return TblHtml;
  }

  GetApplicationLanguages():Observable<any>
  {
    return this.http.get<any>(environment.baseUrl + 'ADM0000/GetApplicationLanguages');
  }
  
  ChangeLanguage(id):Observable<any>
  { 
    return this.http.get<any>(environment.baseUrl + 'ADM0000/ChangeLanguage/'+id);
  }

  ChangeCompany(id):Observable<any>
  {
    return this.http.get<any>(environment.baseUrl + 'ADM0000/ChangeCompany/'+id);
  }

  SwitchUserType(id):Observable<any>
  {
    return this.http.get<any>(environment.baseUrl + 'ADM0000/SwitchUserType/'+id);
  }

  GetCompanyWithPermission():Observable<any>
  {
    return this.http.get<any>(environment.baseUrl + 'ADM0000/GetCompanyWithPermission');
  }

  Logout():Observable<any>
  {
    return this.http.get<any>(environment.baseUrl + 'ADM0000/Logout');
  }

  exportSingleSheetExcel(sheet1Data, sheetName1, fileName) {
    // Create a new workbook and add sheets
    const wb = XLSX.utils.book_new();

    // Convert arrays to sheets
    const ws1 = XLSX.utils.aoa_to_sheet(sheet1Data);
    XLSX.utils.book_append_sheet(wb, ws1, sheetName1);
 
    // Save the file
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

exportMultiSheetAccrualExcel(
  sheet1Data,
  sheet2Data,
  sheet3Data,
  sheetName1,
  sheetName2,
  sheetName3,
  fileName,
  fromDate,
  toDate
) {
  const headingText = `Accrual Report for the Period Between ${fromDate} and ${toDate}`;
  const headingRow = [headingText]; // A1 (first column)

const wb = XLSX.utils.book_new();
const applyHeadingStyle = (ws: XLSX.WorkSheet, data: any[][]) => {
const colCount = data[0].length || 1;

  // Style the heading cell A1
  const headingCell = ws['A1'];
  if (headingCell) {
    headingCell.s = {
      font: {
        bold: true,
        sz: 16,
      },
      alignment: {
        horizontal: 'left',
        vertical: 'center',
      }
    };

    // Merge A1 across all columns
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }
    ];
  }

  // Set custom row heights
  ws['!rows'] = [
    { hpt: 28 }, // Heading row height
    { hpt: 20 }  // Header row height
  ];

  // Style header row (row 2)
  for (let col = 0; col < colCount; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col });
    const cell = ws[cellAddress];
    if (cell) {
      cell.s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "5E8BC2" }
        },
        font: {
          bold: true,
          color: { rgb: "FFFFFF" }
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center'
        }
      };
    }
  }
};
  if (sheet1Data && sheet1Data.length !== 0) {
    const dataWithHeading = [headingRow].concat(sheet1Data);
    const ws1 = XLSX.utils.aoa_to_sheet(dataWithHeading);
    applyHeadingStyle(ws1, sheet1Data);
    XLSX.utils.book_append_sheet(wb, ws1, sheetName1);
    this.adjustColumnWidth(ws1);
    this.addFilterToHeaderAccrual(ws1);
  }

  if (sheet2Data && sheet2Data.length !== 0) {
    const dataWithHeading = [headingRow].concat(sheet2Data);
    const ws2 = XLSX.utils.aoa_to_sheet(dataWithHeading);
    applyHeadingStyle(ws2, sheet2Data);
    XLSX.utils.book_append_sheet(wb, ws2, sheetName2);
    this.adjustColumnWidth(ws2);
    this.addFilterToHeaderAccrual(ws2);
  }

  if (sheet3Data && sheet3Data.length !== 0) {
    const dataWithHeading = [headingRow].concat(sheet3Data);
    const ws3 = XLSX.utils.aoa_to_sheet(dataWithHeading);
    applyHeadingStyle(ws3, sheet3Data);
    XLSX.utils.book_append_sheet(wb, ws3, sheetName3);
    this.adjustColumnWidth(ws3);
    this.addFilterToHeaderAccrual(ws3);
  }


  XLSX.writeFile(wb, fileName + '.xlsx', { 
  bookType: 'xlsx',
  cellStyles: true 
});
}


exportMultiSheetExcel(sheet1Data, sheet2Data, sheet3Data,sheet8Data,sheet9Data,sheet10Data,sheet11Data,sheet4Data,sheet5Data,sheet6Data,sheet7Data, sheetName1, sheetName2, sheetName3,sheetName8,sheetName9,sheetName10,sheetName11,sheetName4,sheetName5,sheetName6,sheetName7,fileName) {
    // Create a new workbook and add sheets
    const wb = XLSX.utils.book_new();
    if(sheet1Data != undefined && sheet1Data != "," && sheet1Data != "" && sheet1Data.length!=0)
    {
      const ws1 = XLSX.utils.aoa_to_sheet(sheet1Data);
      XLSX.utils.book_append_sheet(wb, ws1, sheetName1);
      this.adjustColumnWidth(ws1);
      this.addFilterToHeader(ws1);
    }
    if(sheet2Data != undefined && sheet2Data != "," && sheet2Data != "" && sheet2Data.length!=0)
    {
      const ws2 = XLSX.utils.aoa_to_sheet(sheet2Data);
      XLSX.utils.book_append_sheet(wb, ws2, sheetName2);
      this.adjustColumnWidth(ws2);
      this.addFilterToHeader(ws2);
    }

    // if(sheet2Data != undefined && sheet2Data != "," && sheet2Data != "" && sheet2Data.length!=0)
    // {
    //   const ws2 = XLSX.utils.aoa_to_sheet(sheet2Data);
    //   XLSX.utils.book_append_sheet(wb, ws2, sheetName2);
    //   this.adjustColumnWidth(ws2);
    //   this.addFilterToHeader(ws2);
    // }

    if(sheet3Data != undefined && sheet3Data != "," && sheet3Data != "" && sheet3Data.length!=0)
    {
      const ws3 = XLSX.utils.aoa_to_sheet(sheet3Data);
      XLSX.utils.book_append_sheet(wb, ws3, sheetName3);
      this.adjustColumnWidth(ws3);
      this.addFilterToHeader(ws3);
    }

    if(sheet8Data != undefined && sheet8Data != "," && sheet8Data != "" && sheet8Data.length!=0)
    {
      const ws3 = XLSX.utils.aoa_to_sheet(sheet8Data);
      XLSX.utils.book_append_sheet(wb, ws3, sheetName8);
      this.adjustColumnWidth(ws3);
      this.addFilterToHeader(ws3);
    }

    if(sheet9Data != undefined && sheet9Data != "," && sheet9Data != "" && sheet9Data.length!=0)
    {
      const ws3 = XLSX.utils.aoa_to_sheet(sheet9Data);
      XLSX.utils.book_append_sheet(wb, ws3, sheetName9);
      this.adjustColumnWidth(ws3);
      this.addFilterToHeader(ws3);
    }

    if(sheet10Data != undefined && sheet10Data != "," && sheet10Data != "" && sheet10Data.length!=0)
    {
      const ws3 = XLSX.utils.aoa_to_sheet(sheet10Data);
      XLSX.utils.book_append_sheet(wb, ws3, sheetName10);
      this.adjustColumnWidth(ws3);
      this.addFilterToHeader(ws3);
    }

    if(sheet11Data != undefined && sheet11Data != "," && sheet11Data != "" && sheet11Data.length!=0)
    {
      const ws3 = XLSX.utils.aoa_to_sheet(sheet11Data);
      XLSX.utils.book_append_sheet(wb, ws3, sheetName11);
      this.adjustColumnWidth(ws3);
      this.addFilterToHeader(ws3);
    }
  
    if(sheet4Data != undefined && sheet4Data != "," && sheet4Data != "" && sheet4Data.length!=0)
    {
      const ws4 = XLSX.utils.aoa_to_sheet(sheet4Data);
      XLSX.utils.book_append_sheet(wb, ws4, sheetName4);
      this.adjustColumnWidth(ws4);
      this.addFilterToHeader(ws4);
    }

    if(sheet5Data != undefined && sheet5Data != "," && sheet5Data != "" && sheet5Data.length!=0)
      {
        const ws4 = XLSX.utils.aoa_to_sheet(sheet5Data);
        XLSX.utils.book_append_sheet(wb, ws4, sheetName5);
        this.adjustColumnWidth(ws4);
        this.addFilterToHeader(ws4);
      }
      if(sheet6Data != undefined && sheet6Data != "," && sheet6Data != "" && sheet6Data.length!=0)
        {
          const ws4 = XLSX.utils.aoa_to_sheet(sheet6Data);
          XLSX.utils.book_append_sheet(wb, ws4, sheetName6);
          this.adjustColumnWidth(ws4);
          this.addFilterToHeader(ws4);
        }

        if(sheet7Data != undefined && sheet7Data != "," && sheet7Data != "" && sheet7Data.length!=0)
          {
            const ws4 = XLSX.utils.aoa_to_sheet(sheet7Data);
            XLSX.utils.book_append_sheet(wb, ws4, sheetName7);
            this.adjustColumnWidth(ws4);
            this.addFilterToHeader(ws4);
          }
    
    // Save the file
    XLSX.writeFile(wb, fileName + '.xlsx');
}
DownloadCRMExcel(TableName: string, FileName: string, SubHeading: string): void {
  const oTable = document.getElementById(TableName) as HTMLTableElement;
  const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(oTable, { raw: true });

  // Convert numeric strings to numbers
  const range = XLSX.utils.decode_range(worksheet['!ref']!);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellRef];

      if (
        cell &&
        typeof cell.v === 'string' &&
        cell.v.trim() !== '' &&
        !isNaN(Number(cell.v)) &&
        !/^0\d+/.test(cell.v.trim())
      ) {
        cell.v = Number(cell.v);
        cell.t = 'n';
      }
    }
  }

  const numCols = range.e.c - range.s.c + 1;

  // Shift table down by 2 rows
  const newSheet: XLSX.WorkSheet = {};

  Object.keys(worksheet).forEach(key => {
    if (key[0] === '!') return;

    const cell = XLSX.utils.decode_cell(key);

    const newKey = XLSX.utils.encode_cell({
      r: cell.r + 2,
      c: cell.c
    });

    newSheet[newKey] = worksheet[key];
  });

  // Copy worksheet metadata
  Object.keys(worksheet).forEach(key => {
    if (key[0] === '!') {
      newSheet[key] = worksheet[key];
    }
  });

  // Add Main Heading and Sub Heading
  XLSX.utils.sheet_add_aoa(
    newSheet,
    [
      [FileName],
      [SubHeading]
    ],
    { origin: "A1" }
  );

  // Merge headings
  newSheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: numCols - 1 } }
  ];

  // Update worksheet range
  newSheet["!ref"] = XLSX.utils.encode_range({
    s: { r: 0, c: 0 },
    e: { r: range.e.r + 2, c: range.e.c }
  });

  // Main Heading Style
  if (newSheet["A1"]) {
    newSheet["A1"].s = {
      alignment: {
        horizontal: "left",
        vertical: "center"
      },
      font: {
        bold: true,
        sz: 16,
        underline: true,
        color: { rgb: "000000" }
      }
    };
  }

  // Sub Heading Style
  if (newSheet["A2"]) {
    newSheet["A2"].s = {
      alignment: {
        horizontal: "left",
        vertical: "center"
      },
      font: {
        bold: true,
        sz: 11,
        color: { rgb: "555555" }
      }
    };
  }

  // Header Style (Row 3)
  for (let C = range.s.c; C <= range.e.c; ++C) {

    const headerRef = XLSX.utils.encode_cell({
      r: 2,
      c: C
    });

    const headerCell = newSheet[headerRef];

    if (headerCell) {
      headerCell.s = {
        fill: {
          fgColor: { rgb: "D9E1F2" }
        },
        font: {
          bold: true,
          color: { rgb: "000000" }
        },
        alignment: {
          horizontal: "center",
          vertical: "center"
        },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } }
        }
      };
    }
  }

  // Auto column width
  const colWidths = [];

  for (let C = range.s.c; C <= range.e.c; ++C) {

    let maxWidth = 10;

    for (let R = 0; R <= range.e.r + 2; ++R) {

      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = newSheet[cellRef];

      if (cell && cell.v != null) {
        maxWidth = Math.max(maxWidth, cell.v.toString().length);
      }
    }

    colWidths.push({ wch: maxWidth + 2 });
  }

  newSheet["!cols"] = colWidths;

  // Auto Filter (Header Row)
  newSheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 2, c: 0 },
      e: { r: 2, c: range.e.c }
    })
  };

  // Workbook
  const workbook: XLSX.WorkBook = {
    Sheets: {
      Sheet1: newSheet
    },
    SheetNames: ["Sheet1"]
  };

  XLSX.writeFile(workbook, FileName + ".xlsx");
}

DownloadTaskExcel(TableName: string, FileName: string): void {
 const oTable = document.getElementById(TableName) as HTMLTableElement;
  const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(oTable, { raw: true });

  // Fix number conversion
  const range = XLSX.utils.decode_range(worksheet['!ref']!);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellRef];
      if (
        cell &&
        typeof cell.v === 'string' &&
        cell.v.trim() !== '' &&
        !isNaN(Number(cell.v)) &&
        !/^0\d+/.test(cell.v.trim())
      ) {
        cell.v = Number(cell.v);
        cell.t = 'n';
      }
    }
  }

  const numCols = range.e.c - range.s.c + 1;

  // --- Shift all table data down by ONE row ---
  const newSheet: XLSX.WorkSheet = {};
  Object.keys(worksheet).forEach(key => {
    if (key[0] === '!') return;
    const cell = XLSX.utils.decode_cell(key);
    const newKey = XLSX.utils.encode_cell({ r: cell.r + 1, c: cell.c }); // shift by 1
    newSheet[newKey] = worksheet[key];
  });

  // Copy meta
  Object.keys(worksheet).forEach(key => {
    if (key[0] === '!') newSheet[key] = worksheet[key];
  });

  // --- Add "Task Report" heading at A1 ---
  XLSX.utils.sheet_add_aoa(newSheet, [[FileName]], { origin: "A1" });

  // Merge heading across all columns
  newSheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }
  ];

  // --- Update worksheet reference ---
  const updatedRange = XLSX.utils.encode_range({
    s: { r: 0, c: 0 },
    e: { r: range.e.r + 1, c: range.e.c }
  });
  newSheet['!ref'] = updatedRange;

  // --- Style the Task Report heading ---
  const titleCell = newSheet['A1'];
  if (titleCell) {
    titleCell.s = {
      fill: { fgColor: { rgb: "FFFFFF" } },
      alignment: { horizontal: "left", vertical: "center" },
      font: {
        bold: true,
        sz: 16, // Bigger font size
        underline: true, // Underlined
        color: { rgb: "000000" }
      }
    };
  }

  // --- Style Header Row (Now row 2 = index 1) ---
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const headerRef = XLSX.utils.encode_cell({ r: 1, c: C });
    const headerCell = newSheet[headerRef];
    if (headerCell) {
      headerCell.s = {
        fill: { fgColor: { rgb: "D9E1F2" } }, // Light blue background
        font: { bold: true, color: { rgb: "000000" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } }
        }
      };
    }
  }

  // --- Auto Column Width ---
  const colWidths = [];
  for (let C = range.s.c; C <= range.e.c; ++C) {
    let maxWidth = 10;
    for (let R = 0; R <= range.e.r + 1; ++R) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = newSheet[cellRef];
      if (cell && cell.v != null) {
        const cellValue = cell.v.toString();
        maxWidth = Math.max(maxWidth, cellValue.length);
      }
    }
    colWidths.push({ wch: maxWidth + 2 });
  }
  newSheet['!cols'] = colWidths;

  // --- Add Filter to Header Row (Row 2 / Index 1) ---
  newSheet['!autofilter'] = {
    ref: XLSX.utils.encode_range({
      s: { r: 1, c: 0 },
      e: { r: 1, c: range.e.c }
    })
  };

  // --- Create Workbook ---
  const workbook: XLSX.WorkBook = {
    Sheets: { 'Sheet1': newSheet },
    SheetNames: ['Sheet1'],
  };

  XLSX.writeFile(workbook, FileName + '.xlsx');
}

// Matches the on-screen "report panel" look (light-grey title band,
// grey header row, banded rows) used by cr0080-report-new. Kept as
// its own function, separate from DownloadCRMExcel/DownloadTaskExcel
// above, since those are shared by other reports that still want the
// plain print-style export - and built directly from the component's
// own column/row data (not scraped from the rendered DOM table), so
// the exported values and their types always match what's on screen.
//
// NOTE: xlsx-js-style requires fill.patternType: 'solid' on every
// fill or the background colour is silently dropped even though
// fgColor is set - that's what made the previous DOM-scraped version
// of this export come out with no background/font colours at all.
DownloadReportPanelExcel(columns: string[], data: any[], FileName: string, GeneratedOn: string): void {

  const numCols = columns.length;
  const totalRecords = data.length;
  const TITLE_ROW = 0;
  const META_ROW = 1;
  const HEADER_ROW = 2;
  const DATA_START_ROW = 3;

  const aoa: any[][] = [
    [FileName],
    [`Generated on: ${GeneratedOn}    |    Total Records: ${totalRecords}`],
    columns,
    ...data.map(row => columns.map(col => {
      const v = row[col];
      // Force everything to text rather than letting aoa_to_sheet infer
      // number types: fields like Mobile Number / Relation Track No are
      // identifiers that may already come through as real numbers from
      // the API, and Excel renders long ones in scientific notation
      // (e.g. 1212121212121 -> "1.21212E+12"). This report is a
      // read-only display export, not a calculation sheet, so plain
      // text for every cell - matching exactly what's shown on screen
      // - is what's wanted here, not Excel's numeric reformatting.
      return v == null ? '' : String(v);
    }))
  ];

  const sheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(aoa);

  sheet['!merges'] = [
    { s: { r: TITLE_ROW, c: 0 }, e: { r: TITLE_ROW, c: numCols - 1 } },
    { s: { r: META_ROW, c: 0 }, e: { r: META_ROW, c: numCols - 1 } }
  ];

  const TITLE_BAND_FILL = 'E9E9EE';
  const HEADER_FILL = 'D9D9DE';
  const BAND_FILL = 'FAFAFC';
  const DARK_TEXT = '2B2F3A';
  const META_TEXT = '55565F';
  const BODY_TEXT = '33343D';

  const solidFill = (rgb: string) => ({ patternType: 'solid', fgColor: { rgb }, bgColor: { rgb } });

  // Title band + meta row - fill every cell across the merged range so
  // the band's colour spans the full row width, not just column A.
  for (let C = 0; C < numCols; ++C) {
    const titleRef = XLSX.utils.encode_cell({ r: TITLE_ROW, c: C });
    sheet[titleRef] = sheet[titleRef] || { t: 's', v: '' };
    sheet[titleRef].s = {
      fill: solidFill(TITLE_BAND_FILL),
      font: { bold: true, sz: 14, color: { rgb: DARK_TEXT } },
      alignment: { horizontal: 'left', vertical: 'center' }
    };

    const metaRef = XLSX.utils.encode_cell({ r: META_ROW, c: C });
    sheet[metaRef] = sheet[metaRef] || { t: 's', v: '' };
    sheet[metaRef].s = {
      fill: solidFill(TITLE_BAND_FILL),
      font: { italic: true, sz: 10, color: { rgb: META_TEXT } },
      alignment: { horizontal: 'left', vertical: 'center' },
      border: {
        bottom: { style: 'medium', color: { rgb: '811458' } }
      }
    };
  }

  // Column header row (mirrors .report-table thead th).
  for (let C = 0; C < numCols; ++C) {
    const ref = XLSX.utils.encode_cell({ r: HEADER_ROW, c: C });
    if (!sheet[ref]) continue;
    sheet[ref].s = {
      fill: solidFill(HEADER_FILL),
      font: { bold: true, sz: 10, color: { rgb: DARK_TEXT } },
      alignment: { horizontal: 'left', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: 'C7C7D3' } },
        bottom: { style: 'thin', color: { rgb: 'C7C7D3' } },
        left: { style: 'thin', color: { rgb: 'C7C7D3' } },
        right: { style: 'thin', color: { rgb: 'C7C7D3' } }
      }
    };
  }

  // Data rows - banded, matching .report-table tbody tr:nth-child(even).
  for (let i = 0; i < totalRecords; ++i) {
    const R = DATA_START_ROW + i;
    const isBanded = i % 2 === 1;
    for (let C = 0; C < numCols; ++C) {
      const ref = XLSX.utils.encode_cell({ r: R, c: C });
      if (!sheet[ref]) continue;
      sheet[ref].s = {
        fill: solidFill(isBanded ? BAND_FILL : 'FFFFFF'),
        font: { sz: 10, color: { rgb: BODY_TEXT } },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          bottom: { style: 'thin', color: { rgb: 'ECECF1' } },
          left: { style: 'thin', color: { rgb: 'ECECF1' } },
          right: { style: 'thin', color: { rgb: 'ECECF1' } }
        }
      };
    }
  }

  // Auto column width.
  const colWidths = columns.map((col, C) => {
    let maxWidth = Math.max(10, col.toString().length);
    for (let i = 0; i < totalRecords; ++i) {
      const ref = XLSX.utils.encode_cell({ r: DATA_START_ROW + i, c: C });
      const cell = sheet[ref];
      if (cell && cell.v != null) {
        maxWidth = Math.max(maxWidth, cell.v.toString().length);
      }
    }
    return { wch: maxWidth + 2 };
  });
  sheet['!cols'] = colWidths;

  sheet['!autofilter'] = {
    ref: XLSX.utils.encode_range({
      s: { r: HEADER_ROW, c: 0 },
      e: { r: HEADER_ROW, c: numCols - 1 }
    })
  };

  const workbook: XLSX.WorkBook = {
    Sheets: { Sheet1: sheet },
    SheetNames: ['Sheet1']
  };

  XLSX.writeFile(workbook, FileName + '.xlsx');
}

// Function to adjust column width based on content
adjustColumnWidth(sheet) {
 
  const columnWidths = {};
  const range = XLSX.utils.decode_range(sheet['!ref']); // Get the range of cells

  // Iterate over all rows and columns to determine the max content length
  for (let R = range.s.r; R <= range.e.r; R++) {
    // Iterate over each row using the row index
    for (let C = range.s.c; C <= range.e.c; C++) {
      
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C }); // Get the cell address like 'A1', 'B2', etc.
      const cell = sheet[cellAddress]; // Access the cell by its address

      if (cell && cell.v) {
        const column = XLSX.utils.encode_col(C); // Get the column name (A, B, C, etc.)
        const length = cell.v.toString().length;
        // Add extra padding to ensure the width is sufficient
        const padding =0; // You can adjust this value if needed
        const adjustedLength = length + padding;
        
        if (columnWidths[column] === undefined || columnWidths[column] < adjustedLength) {
          columnWidths[column] = adjustedLength;
        }
      }
    }
  }

  // Set the width for each column
  const wscols = Object.keys(columnWidths).map((column) => ({
    wch: columnWidths[column]
  }));

  sheet['!cols'] = wscols;
}
// Function to add a filter to the header row
// Function to add a filter to the header row
addFilterToHeader(sheet: XLSX.WorkSheet) {
  // Get the range of cells in the sheet
  const range = XLSX.utils.decode_range(sheet['!ref']);
  
  // Add autofilter to the header row
  sheet['!autofilter'] = {
      ref: XLSX.utils.encode_range({
          s: { r: range.s.r, c: range.s.c }, // Start from the first row and first column
          e: { r: range.s.r, c: range.e.c }  // End at the first row and last column (header row)
      })
  };
}
addFilterToHeaderAccrual(sheet: XLSX.WorkSheet) {
  // Get the range of cells in the sheet
  const range = XLSX.utils.decode_range(sheet['!ref']);

  // Apply autofilter to the second row (row index 1, since index is 0-based)
  sheet['!autofilter'] = {
    ref: XLSX.utils.encode_range({
      s: { r: 1, c: range.s.c },   // Start at row 2 (index 1), first column
      e: { r: 1, c: range.e.c }    // End at row 2 (index 1), last column
    })
  };
}
downloadAttachment(fileNameServer: string, Compid: string, pageName: string): Observable<HttpResponse<Blob>> {

  const url = `${this.baseUrl}DownloadAttachment?fileNameServer=${encodeURIComponent(fileNameServer)}&CompId=${encodeURIComponent(Compid)}&pageName=${encodeURIComponent(pageName)}`;

  return this.http.get(url, {
    responseType: 'blob',
    observe: 'response'
  });

}

}
function setCellStyle(cellRef: string, arg1: string) {
  throw new Error('Function not implemented.');
}

